const SOCIALS: Array<{ icon: string; href: string; label: string }> = [
  { icon: 'facebook-f', href: 'https://www.facebook.com/PeopleGroupServices', label: 'Facebook' },
  { icon: 'vimeo-v', href: 'https://vimeo.com/peoplegroup', label: 'Vimeo' },
  { icon: 'x-twitter', href: '#', label: 'X (Twitter)' },
  { icon: 'linkedin-in', href: 'https://www.linkedin.com/company/people-group-ltd/', label: 'LinkedIn' },
];

const POLICIES: Array<{ label: string; href: string }> = [
  {
    label: 'Anti Slavery Policy',
    href: 'https://peoplegroupservices.com/wp-content/uploads/2019/01/Anti-Slavery-Policy-People-Group-Service-Oct19.pdf',
  },
  {
    label: 'Anti Corruption & Bribery',
    href: 'https://peoplegroupservices.com/wp-content/uploads/2019/01/Anti_Corruption__Bribary_Policy_PeopleGroupServices-Oct19.pdf',
  },
  {
    label: 'People GDPR',
    href: 'https://peoplegroupservices.com/wp-content/uploads/2019/01/1-People-Main-GDPR-statement-V2-Oct19.pdf',
  },
  { label: 'Privacy Policy', href: 'https://peoplegroupservices.com/privacy-policy/' },
];

export const Footer = () => (
  <footer className="bg-[#0a1530] px-8 pb-5 pt-10 text-[13px] text-white/70">
    <div className="mb-7 flex flex-col items-center justify-between gap-4 border-b border-white/10 pb-5 md:flex-row">
      <img src="/logo.webp" alt="People Group Services" className="h-10 opacity-90" />
      <div className="flex gap-3.5">
        {SOCIALS.map(({ icon, href, label }) => {
          const external = href !== '#';
          return (
            <a
              key={icon}
              href={href}
              aria-label={label}
              {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
              className="text-base text-white/60 hover:text-teal"
            >
              <i className={`fab fa-${icon}`} />
            </a>
          );
        })}
      </div>
    </div>
    <div className="mb-7 grid gap-8 md:grid-cols-[2fr_1fr_1fr]">
      <div>
        <h6 className="mb-3 text-[11px] font-bold uppercase tracking-[1.5px] text-white">
          People Group Services
        </h6>
        <p className="leading-relaxed">
          People Group House
          <br />
          Three Horseshoes Walk
          <br />
          Warminster, Wiltshire BA12 9BT
        </p>
        <p className="mt-2 leading-relaxed">
          Tel:{' '}
          <a href="tel:+443450341530" className="hover:text-teal">
            0345 034 1530
          </a>
          <br />
          Email:{' '}
          <a href="mailto:clientcare@peoplegroupservices.com" className="hover:text-teal">
            clientcare@peoplegroupservices.com
          </a>
        </p>
      </div>
      <div>
        <h6 className="mb-3 text-[11px] font-bold uppercase tracking-[1.5px] text-white">
          Opening Times
        </h6>
        <p className="leading-relaxed">
          Monday to Friday
          <br />
          9am – 5pm
        </p>
      </div>
      <div>
        <h6 className="mb-3 text-[11px] font-bold uppercase tracking-[1.5px] text-white">
          Policies
        </h6>
        {POLICIES.map(({ label, href }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="mb-1.5 block text-xs text-white/60 transition-colors hover:text-teal"
          >
            {label}
          </a>
        ))}
      </div>
    </div>
    <div className="border-t border-white/5 pt-4 text-center text-[11px] text-white/40">
      © Copyright 2021 People. All rights reserved
    </div>
  </footer>
);
